import {
  RecordVoiceOver,
  Groups2Outlined,
  RoofingOutlined,
  CoPresentOutlined,
  BadgeOutlined,
  SupportAgentOutlined,
  VideoSettingsOutlined,
  FestivalOutlined,
  HelpOutline,
} from '@mui/icons-material';

export const iconMap = {
  RecordVoiceOver,
  Groups2Outlined,
  RoofingOutlined,
  CoPresentOutlined,
  BadgeOutlined,
  SupportAgentOutlined,
  VideoSettingsOutlined,
  FestivalOutlined,
  HelpOutline,
};

export const iconNames = Object.keys(iconMap) as Array<keyof typeof iconMap>;
export type IconName = (typeof iconNames)[number];

export const isValidIconName = (icon: string): icon is IconName => {
  return iconNames.includes(icon as IconName);
};
